/**
 * Dashboard API functions
 */

import { apiRequest } from "@/lib/queryClient";
import type { DashboardData } from "../types";

/**
 * Fetch dashboard summary data
 */
export async function getDashboardSummary(): Promise<DashboardData> {
  const res = await apiRequest("GET", "/dashboard-summary");

  if (!res.ok) {
    const errorData = await res.json().catch(() => ({ error: "Failed to load dashboard" }));
    throw new Error(errorData.message || errorData.error || `Server error: ${res.status}`);
  }

  const data = await res.json();

  // Ensure data structure is valid
  if (data && typeof data === 'object') {
    return {
      recentQuotes: Array.isArray(data.recentQuotes) ? data.recentQuotes : [],
      recentJobs: Array.isArray(data.recentJobs) ? data.recentJobs : [],
      recentInvoices: Array.isArray(data.recentInvoices) ? data.recentInvoices : [],
      unpaid: data.unpaid && typeof data.unpaid === 'object' ? {
        count: typeof data.unpaid.count === 'number' ? data.unpaid.count : 0,
        total: typeof data.unpaid.total === 'number' ? data.unpaid.total : 0,
      } : { count: 0, total: 0 },
      revenue: data.revenue && typeof data.revenue === 'object' ? {
        total: typeof data.revenue.total === 'number' ? data.revenue.total : 0,
        paid: typeof data.revenue.paid === 'number' ? data.revenue.paid : 0,
      } : undefined,
    };
  }

  throw new Error("Invalid dashboard data format");
}

